const MONITORING_BASE_URL = 'https://tophamtechbeb.com/aw-monitor/v1';

export const CONTACT_ANALYTICS_RANGES = ['7d', '30d', '120d'];

export const getContactAnalyticsActivity = async ({
  user,
  targetUserId,
  chatLeadId,
  range = '30d',
  signal
} = {}) => {
  const numericUserId = targetUserId == null ? null : Number(targetUserId);
  const numericChatLeadId = chatLeadId == null ? null : Number(chatLeadId);
  const hasUserId = Number.isInteger(numericUserId) && numericUserId > 0;
  const hasChatLeadId = Number.isInteger(numericChatLeadId) && numericChatLeadId > 0;
  if (hasUserId === hasChatLeadId) {
    throw new Error('A registered contact or linked chat lead is required for analytics activity.');
  }
  if (!CONTACT_ANALYTICS_RANGES.includes(range)) {
    throw new Error('Unsupported analytics date range.');
  }
  if (!user?.token) {
    throw new Error('Your session is missing an authentication token. Please sign in again.');
  }

  const params = new URLSearchParams();
  if (hasUserId) params.set('user_id', String(numericUserId));
  else params.set('chat_lead_id', String(numericChatLeadId));
  params.set('range', range);
  const response = await fetch(
    `${MONITORING_BASE_URL}/analytics/contact-activity?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        Authorization: `${user.type || 'Bearer'} ${user.token}`
      },
      signal
    }
  );

  if (!response.ok) {
    let message = 'Contact analytics are temporarily unavailable.';
    try {
      const payload = await response.json();
      if (payload?.detail) message = payload.detail;
    } catch (error) {
      // Keep the safe fallback for non-JSON server errors.
    }
    throw new Error(message);
  }

  return response.json();
};
